import React, { useState, useEffect ,useRef} from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';
import { Clock, TrendingUp, Truck, MapPin, AlertTriangle, CheckCircle, ChevronDown, Calendar, Search, X, Info } from 'lucide-react';
import './dashboardStyles.css';
import Crud_Catalogos from '../../../../herramientas/Crud_Catalogos';
import { LoadingScreen } from '../../../../components/LoadingScreen';
import { TruckLoader } from '../../../../components/loaderTruck/TruckLoader';
import Select from "react-select";
import { TablePageablePerRequest } from "../../../../Helpers";
import ExcelDownloadLoader from '../../../../components/loaderTruck/ExcelDownloadLoader';
import ModalLayout from "../../../../components/ModalLayout.react";
import {
  Icon
} from "tabler-react";



const DashboardAsignaciones = () => {


  // Obtiene  mes, y dia  del año actual
let dateNow = new Date();

const month = dateNow.toLocaleString("default", { month: "2-digit" });

let startDate = `${dateNow.getFullYear()}-${month}-01`;

const year = dateNow.toLocaleString("default", { year: "numeric" });

const day = dateNow.toLocaleString("default", { day: "2-digit" });

// Genera yyyy-mm-dd date string
const endDate = year + "-" + month + "-" + day;

 
  const [totales, setTotales] = useState([]);
  const [totalesFiltrados, setTotalesFiltrados] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [isloading, setisLoading] = useState(true);
  const [isloaderTable, setisLoaderTable] = useState(true);
  const [LoaderGraficas,setLoaderGraficas] = useState(true);
  const [localidadesOpcion, setlocalidadesOpcion] = useState();
  const [banderaRefresh,setBanderaRefresh] = useState();
  const [fechaInicio,setFechaInicio] = useState(startDate);
  const [fechaFin,setFechaFin] =  useState(endDate);
  // Estado para filtros y vistas
  const [localidadActiva, setLocalidadActiva] = useState([]);
  const [servicioSeleccionado, setServicioSeleccionado] = useState();
  const [menuLocalidadAbierto, setMenuLocalidadAbierto] = useState(false);
    
  // Estado para filtro de fechas
  const [fechasAplicadas, setFechasAplicadas] = useState({ inicio: '', fin: '' });

  // Estado de transportistas
  const [transportistaGrafica,setTransportistaGrafica] = useState();

   // Estado de localidadGrafica
  const [localidadGrafica,setLocalidadGrafica] = useState();
   // Estado de movimientos
  const [movimientos,setMovimientos] = useState();
  const [movimientosFiltrados, setMovimientosFiltrados] = useState();
  // Estado de tamaño de pagina y pagina actual
  const [pagina,setPagina] =  useState(0);
  const [tamaño,setTamaño]= useState(5);
  //Estado de busqueda
  const [busqueda,setBusqueda] = useState("")

  const [movimiento,setMovimiento] =  useState();

  const [dataTaskDownload,setdataTaskDownload] = useState();

  const [plataformaOpcion,setPlataformaOpcion] = useState();

  const [hiddenModals,setHiddenModals] = useState(false);

  const [patio,setPatio]= useState({});
  
 
  var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  let plataformas = [];
  const tamanioAnterior = useRef(tamaño);
  const plataformaAnterior = useRef(plataformaOpcion);
  const busquedaAnterior = useRef(busqueda);
  let  dataTransporte = [];

   
  currentUser.map((usr, index) => {
      if (
        usr.plataforma.plataformaTipo.nombre.toUpperCase().includes("NAVIERA")
      ) {
        plataformas.push({
          value: usr.plataforma.id,
          label: usr.plataforma.nombre,
          search: usr.plataforma.nombre,
        });
      }
      return usr;
  });

   



  
   


   useEffect(() => {
      let url = '';
   
      let idPlataforma =  plataformaOpcion ? plataformaOpcion.value :  plataformas[0].value ;
      url = localidadActiva ?  "?localidades=" + localidadActiva : "?localidades="; 
      url += fechaInicio ? "&fechaInicio=" + fechaInicio : "&fechaInicio="  
      url += fechaFin ? "&fechaFin="  + fechaFin : "&fechaFin="; 
      url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";

       plataformaAnterior.current = plataformaOpcion;
       let cambioPlataforma = plataformaAnterior && validarCambioTamaño(plataformaOpcion, plataformaAnterior); 
   
      if(localidadActiva.length > 0 || fechaInicio && fechaFin  || !movimientosFiltrados || busqueda || cambioPlataforma){
             getfuntion("get", "", "", "reporteAsignaciones/graficas/" +idPlataforma  + url)
      }


      
      getfuntion("get", "", "", "reporteAsignaciones/obtieneMovimientosGraph/"+ idPlataforma + url + "&page=" + pagina  +"&size=" + tamaño )

      
    }, [localidadActiva,fechasAplicadas,plataformaOpcion]);

    
    useEffect(() => {
      let url = '';
 
      let idPlataforma =  plataformaOpcion ? plataformaOpcion.value :  plataformas[0].value ;
       url = localidadActiva ?  "?localidades=" + localidadActiva : "?localidades="; 
      let cambioBusqueda = busqueda && validarCambioTamaño(busquedaAnterior, busqueda);
       if(!cambioBusqueda){
        url += fechaInicio ? "&fechaInicio=" + fechaInicio : "&fechaInicio=" 
        url += fechaFin ? "&fechaFin="  + fechaFin : "&fechaFin="; 
       }else{
        url += "&fechaInicio=" 
         url+= "&fechaFin="; 
       }
        
      
       url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";

        tamanioAnterior.current = tamaño;
        let cambioTamaño = tamanioAnterior && validarCambioTamaño(tamaño, tamanioAnterior); 
       if(pagina > 0  || cambioTamaño ){
        getfuntion("get", "", "", "reporteAsignaciones/obtieneMovimientosGraph/"+ idPlataforma + url + "&page=" + ( pagina == 0 ? pagina : pagina -1)  +"&size=" + tamaño )

       }

     }, [pagina,tamaño,busqueda]);



    const validarCambioTamaño = (tamanioActual, tamanioAnterior) => {
      return tamanioActual !== tamanioAnterior;
    };

    const hiddenmodal = () => {

      setHiddenModals(!hiddenModals);
 
    };


// se define la funcion de axios para consumir api
  const getfuntion = (
     metodo = "get",
     params,
     id = "",
     endPoint,
     stateVar = "",
     hiddenModl = ""
   ) => {
     Crud_Catalogos(
       endPoint,
       "",
       metodo,
       id,
       params,
 
     ).then((returnVal) => {
      console.log(returnVal)
         switch (metodo) {
           case "get":
             {
              
               if (returnVal && endPoint.includes("graficas")) {
                plataformaAnterior.current = plataformaOpcion;
                let cambioPlataforma = plataformaAnterior && validarCambioTamaño(plataformaOpcion, plataformaAnterior); 
                if(totales.length < 1  || cambioPlataforma){
                  setTotales(returnVal);
                }
                 setLoaderGraficas(false)
                 setTotalesFiltrados(returnVal);
                 setLocalidadGrafica(obtenerComparativaLocalidades(returnVal));
                 getfuntion("get", "", "", "localidades");
               }

               if (returnVal && !endPoint.includes("graficas") && !endPoint.includes("obtieneMovimientos") && !endPoint.includes("download")) {
        
                console.log(returnVal)
                let  localidadesOpcionesTemp  = [];
              
                returnVal.forEach((key) => localidadesOpcionesTemp.push({ value: key.id, label: key.nombre}));
                setLocalidades(localidadesOpcionesTemp);
                setisLoading(false);
               
               }

               if (returnVal && endPoint.includes("obtieneMovimientos")) {
        
            
                if(!movimientos){
                  setMovimientos(returnVal);
                }
                  setMovimientosFiltrados(returnVal);
                  setisLoading(false);

                  setisLoaderTable(false);
               
               }

               if(returnVal && endPoint.includes("download/start")){
                setdataTaskDownload(returnVal)
               }
             }
             break;
           case "post":
            
           break;
            default:
             break;
         }
         
       })
       .catch((err) => {
        console.log(err)
         if (err.response) {
           console.log(err.response);
         } else {
           /**
            * Error
            */
           console.log("Error desconocido ...." + err);
         }
       });
   };

  // // Datos para gráficos
  const datosPie = [
    { name: 'En tiempo', value: totalesFiltrados.enTiempo, color: 'var(--color-en-tiempo)' },
    { name: 'Retrasados', value: totalesFiltrados.retrasados, color: 'var(--color-retrasado)' },
    { name: 'Sin calculo', value: totalesFiltrados.sinCalculo, color: 'var(--color-sinCalculo)' }
  ];
  
  const downloadExcel =()=>{
let idPlataforma =  plataformaOpcion ? plataformaOpcion.value :  plataformas[0].value ;
    let url = '';
    url = localidadActiva ?  "&localidades=" + localidadActiva : "&localidades="; 
    url += fechaInicio ? "&fechaInicio=" + fechaInicio : "&fechaInicio="  
    url += fechaFin ? "&fechaFin="  + fechaFin : "&fechaFin="; 
    url += busqueda ? "&movimiento=" + busqueda : "&movimiento=";
    getfuntion("get","","","reporteAsignaciones/download/start?plataforma="+ idPlataforma+ url)
  }

  
  

  
  // Comparativa entre localidades
  const obtenerComparativaLocalidades = (data) => {
    console.log(data)
    return data.localidades.map(loc => {
      
      const total = loc.total;
      const enTiempo = loc.enTiempo
      const retrasados = loc.retrasados
      const porcentage = 100 * loc.enTiempo / loc.total

      
      return {
        localidad: loc.nombre,
        total,
        enTiempo,
        retrasados,
        porcentage
      };
    });
  };
  
  

  
  // Seleccionar localidad
  const seleccionarLocalidad = (localidad) => {
    setLocalidadActiva(localidad);
    setMenuLocalidadAbierto(false);
  };
  
  // Aplicar filtro de fechas
  const aplicarFiltroFechas = () => {
    setisLoading(true);
    setPagina(0)
    setLoaderGraficas(true);
    setFechasAplicadas({
      inicio: fechaInicio,
      fin: fechaFin
    });
  };
  
  // Limpiar filtro de fechas
  const limpiarFiltroFechas = () => {
    setisLoading(true);
    setLoaderGraficas(true);
    setFechaInicio('');
    setFechaFin('');
    setFechasAplicadas({ inicio: '', fin: '' });
    if(localidadActiva.length ==0){
        setTotalesFiltrados(totales)
    }
  
  
  };


    // Función principal para comparar fechas
  const compararFechas = (fechaInicio, fechaFin) => {
    try {
      // Validar formato de fecha
      const formatoFecha = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      
      if (!formatoFecha.test(fechaInicio) || !formatoFecha.test(fechaFin)) {
        throw new Error('Formato de fecha inválido. Use: YYYY-MM-DD HH:mm:ss');
      }

      // Convertir strings a objetos Date
      const date1 = new Date(fechaInicio.replace(' ', 'T'));
      const date2 = new Date(fechaFin.replace(' ', 'T'));

      // Verificar que las fechas sean válidas
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        throw new Error('Una o ambas fechas son inválidas');
      }

      // Calcular diferencia en milisegundos
      const diferenciaMilisegundos = Math.abs(date2.getTime() - date1.getTime());

      // Convertir a unidades de tiempo
      const segundosTotales = Math.floor(diferenciaMilisegundos / 1000);
      const minutosTotales = Math.floor(segundosTotales / 60);
      const horasTotales = Math.floor(minutosTotales / 60);
      const diasTotales = Math.floor(horasTotales / 24);

      // Determinar cuál fecha es mayor
      const fechaMayor = date2 > date1 ? fechaFin : fechaInicio;
      const fechaMenor = date2 > date1 ? fechaInicio : fechaFin;

      // Determinar la unidad más apropiada
      let diferenciaOptima;
      if (diasTotales > 0) {
        diferenciaOptima = {
          valor: diasTotales,
          unidad: 'días',
          texto: `${diasTotales} día${diasTotales !== 1 ? 's' : ''}`
        };
      } else if (minutosTotales > 0) {
        diferenciaOptima = {
          valor: minutosTotales,
          unidad: 'minutos',
          texto: `${minutosTotales} minuto${minutosTotales !== 1 ? 's' : ''}`
        };
      } else {
        diferenciaOptima = {
          valor: segundosTotales,
          unidad: 'segundos',
          texto: `${segundosTotales} segundo${segundosTotales !== 1 ? 's' : ''}`
        };
      }

      console.log(diferenciaOptima)
      

      return {
        success: true,
        fechaMayor,
        fechaMenor,
        diferencia: diferenciaOptima,
        // Datos completos para referencia
        detalles: {
          diasTotales,
          horasTotales,
          minutosTotales,
          segundosTotales
        }
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  };



  // Componente para la tarjeta de métrica
  const TarjetaMetrica = ({ icono, titulo, valor, valorAdicional, colorBorde, colorIcono }) => (
    <div className="card card-bottom-border" style={{borderBottomColor: colorBorde}}>
      <div className="card-body">
        <div className="metrica-contenido">
          <div className="metrica-icono" style={{backgroundColor: colorIcono}}>
            {icono}
          </div>
          <div>
            <div className="metrica-titulo">{titulo}</div>
            <div className="metrica-valor">
              <span className="metrica-numero">{valor}</span>
              {valorAdicional && <span style={{color: colorBorde}}>{valorAdicional}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const obtenerColumnas=()=>{

    let columnas = ["idMovimiento","contenedor","po","estado","booking","tiempoRetraso","Detalle","asignacionvscolocacion"]
    let columnasTemp= [];
    for(let c of columnas){    
      switch (c) {       
     
        case "estado":
          columnasTemp.push({ columna: c, label: c,
            form: (e)=>{
              if( e[c] == 'En Tiempo'){
              
                //(date_part('epoch',(m.arribo_direcion_carga - m.inicio_ruta_vacio)) * interval '1 second')::text
                return  <CheckCircle size={24} color="green" />
              }else if(e[c] == 'Retrasado'){
                return  <AlertTriangle size={24} color="red" />
              }else{
                return<Info size={24} color="white" fill="gray"/>
              }
            }
          });
          break;

        case "idMovimiento":
          columnasTemp.push({ columna: c, label: "Movimiento",
            form: (e)=> e.idMovimiento});
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.destino: e.idCorredor.nombre });
          break;


        case "tiempoRetraso":
          columnasTemp.push({ columna: c, label: "Tiempo de Retraso",
            form: (e)=> e.tiempoRetraso});
          // columnasTemp.push({ columna: c.columna, label: c.label,
          //   form: (e)=> [1,3].includes(e[c.columna])? e.destino: e.idCorredor.nombre });
        break;
  
        case "citaProgramada":
          columnasTemp.push({ columna: c.columna, label: c.label,
            form: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            },
            valor: (e)=>{
              if( c.idFuncionalidad === 2891 && (e.idMovimientoTipo.id === 1 || e.idMovimientoTipo.id === 304) ){//ultima milla
                return e.citaProgramada;
              }else{
                if( c.idFuncionalidad === 2892 && (e.idMovimientoTipo.id === 2 || e.idMovimientoTipo.id === 303) ){//ultima milla
                  return e.citaProgramada;
                }
                return e.citaProgramada
              }
            }
          });
          break;
    
   
        case "contenedor":

        columnasTemp.push({ columna: c, label: c,
          form: (e)=> e.contenedor});
        break;


        case "asignacionvscolocacion":

        columnasTemp.push({ columna: c, label: "Tiempo entre asignacion y colocacion",
          form: (e)=> e.fechaAsignacion && e.fechaInstalacion ?  compararFechas(e.fechaAsignacion,e.fechaInstalacion).diferencia?.texto : "Sin calculo"});
        break;
 
        case "Detalle":
          columnasTemp.push({ columna: c.columna, label: "Detalle",
            // enClick: (e)=>{
            //   setPatio({});
            //   Crud_Catalogos("movimientosPatio/idMovimiento/"+e.idMovimiento,"","get","",[],"","","",[]).then((returnVal)=>{                                                
            //     setPatio(returnVal);
            //   }).catch(err =>{ console.log(err);});
            // },
            enClickDisabled: false,
            form: (e)=>
            <ModalLayout tamanio={'%50%'} title="Movimiento"
              name={<span><Icon prefix="fa" name="question-circle" className={"icon-detalle"}/></span>}
              hiddenModal={hiddenModals} Fclose={hiddenmodal}
              formulario={//999022
                <table className="modal-table">
                <tbody>
                  <tr className="modal-row-odd">
                    <td className="modal-cell-label">ID Movimiento</td>
                    <td className="modal-cell-value">{e.idMovimiento}</td>
                  </tr>
                  <tr>
                    <td className="modal-cell-label">Orden de Trabajo (WO)</td>
                    <td className="modal-cell-value">{e.po}</td>
                  </tr>
                  <tr className="modal-row-odd">
                    <td className="modal-cell-label">Transportista</td>
                    <td className="modal-cell-value">{e.transportista}</td>
                  </tr>
                  <tr>
                    <td className="modal-cell-label">Cliente</td>
                    <td className="modal-cell-value">{e.clientes}</td>
                  </tr>
                  <tr className="modal-row-odd">
                    <td className="modal-cell-label">Inicio Ruta</td>
                    <td className="modal-cell-value">{e.fechaInicioRuta}</td>
                  </tr>
                  <tr className="modal-row-odd">
                    <td className="modal-cell-label">Registro Patio</td>
                    <td className="modal-cell-value">{e.fechaAsignacion}</td>
                  </tr>
                  <tr>
                    <td className="modal-cell-label">Registro GPS</td>
                    <td className="modal-cell-value">{e.fechaInstalacion}</td>
                  </tr>
                  <tr className="modal-row-odd">
                    <td className="modal-cell-label">Diferencia de tiempo</td>
                    <td className="modal-cell-value">{e.tiempoRetraso}</td>
                  </tr>
                  <tr>
                    <td className="modal-cell-label">Estado</td>
                    <td className="modal-cell-value">
                      <span className={`badge-color ${e.estado === 'En Tiempo' ? 'badge-en-tiempo' : 'badge-retrasado'}`}>
                        {e.estado}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          />
          }
            );
          break;
     
          case "registroOperador":
            columnasTemp.push({ columna: c.columna, label: c.label,
              form: (e)=>{
                return <ModalLayout 
                  tamanio={'80%'} 
                  title="Movimiento"
                  name={<span><Icon prefix="fa" name="bullhorn" /></span>}
                  hiddenModal={this.state.hiddenModals} 
                  Fclose={this.hiddenmodal}
                  formulario={
                    <OperadoresNavieros
                        data = {e}
                        accion="modificar"
                        usuario={user}
                        getfuntion={this.getfuntion}
                        stor={this.props}
                        elementos= {this.state.elementosSinfiltrar}
                        closeModal={this.hiddenmodal}
                        readonly={this.state.readonly}
                        updateData = {this.updateData}
                     />  
                  }
                />
              },
            });
            break;
      
        default: columnasTemp.push({ columna: c, label: c });
          break;
      }
    }
    return columnasTemp;
  }

  // Componente para encabezado de gráfico
  const EncabezadoGrafico = ({ titulo }) => (
    <h3 className="grafico-titulo">{titulo}</h3>
  );

  const changePage = (page)=>{
      setisLoaderTable(true);
      setPagina(page)
  }

  const buscarMov=(busqueda)=>{
       setBusqueda(busqueda)
       setPagina(0);
  }

  const handleChangePlataforma = (e)=>{
    setPagina(0);
    setLoaderGraficas(true);
  }

  const handleChangeOptions = (e)=>{
    setisLoading(true);

    let nuevoArray = [...localidadActiva];

    setPagina(0)


    if(e.action == 'select-option'){
       nuevoArray.push(e.option.value);
    }
    
    if(e.action == 'remove-value'){
       let index = nuevoArray.findIndex((item)=> item == e.removedValue.value);
       if(index != -1){
        nuevoArray.splice(index,1) 
        if(nuevoArray.length < 1){
          resetValores();
          
        }
       }
    }

    if(e.action == 'clear'){
    
      if(!fechaInicio && !fechaFin){
        resetValores()
        return;
      }

      nuevoArray = [];
     
    }
    
    setLocalidadActiva(nuevoArray);

  }

  const changeTamaño = (nuevoTamaño) => { 
    // Actualizamos el estado
    setTamaño(nuevoTamaño);
  };

  const resetValores = ()=>{
    setLoaderGraficas(true)
    if(!fechaInicio && !fechaFin){
      setTotalesFiltrados(totales);
      setLocalidadGrafica(obtenerComparativaLocalidades(totales));
    }
   
    setLocalidadActiva([]);
    setisLoading(true)
    setPagina(0);
   
  }

  const resetDownload= ()=>{
    setdataTaskDownload(null);
  }

  return (
   
    <div style={{ backgroundColor: 'var(--color-bg)', minHeight: '100vh' }}>
      {/* Cabecera */}
      <header className="header">
        <div className="container header-content">
          <div className="header-title">
            <Truck className="icon" size={28} color="white" />
            <h2>Monitor de Asignaciones vs Instalaciones</h2>
          </div>
          
          {/* Selector de localidades */}
          <div className="menuAsignaciones">

          <div className="col-12 justify-content-start dropdown-menuAsignaciones">
              <div className="form-group">
                <label for="estatus">Plataformas</label>
                <Select name="plataformas" value={plataformaOpcion ? plataformaOpcion : plataformas[0]} onChange={(e,a)=>{ setPlataformaOpcion(e); handleChangePlataforma(a); }} options={plataformas} />
              </div>
          </div>

          <div className="col-12 justify-content-start dropdown-menuAsignaciones">
              <div className="form-group">
                <label for="estatus">Localidad</label>
                <Select isMulti name="localidades" id="localidades" value={localidadesOpcion} onChange={(e,a)=>{ setlocalidadesOpcion(e); handleChangeOptions(a); }} options={localidades} />
              </div>
            </div>
          
          </div>
        </div>
      </header>
      
      {/* Contenido principal */ }
      { totalesFiltrados ? 
      <main className="container">
        <div>
          {/* Resumen de la localidad actual */}
          <div className="card card-left-border">
            <div className="localidad-resumen">
              <div className="localidad-header">
                <div>
                  <h4 className="localidad-titulo">Localidad: {localidadesOpcion &&  localidadesOpcion.length > 1  ? localidadesOpcion.map(localidad => localidad.label +",") : localidadesOpcion ? localidadesOpcion[0].label : "" }</h4>
                  <p className="localidad-descripcion">
                    Mostrando {totalesFiltrados.total} servicios 
                  </p>
                </div>
                <div className="localidad-stats">
                  <div className="stat-item">
                    <div className="stat-dot stat-dot-en-tiempo"></div>
                    <span className="stat-texto">En tiempo: {totalesFiltrados.enTiempo}</span>
                  </div>
                  <div className="stat-item">
                    <div className="stat-dot stat-dot-retrasado"></div>
                    <span className="stat-texto">Retrasados: {totalesFiltrados.retrasados}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Filtros */}
          <section className="filtros-seccion">
            <div className="filtros-contenedor">
              <div className="filtro-fecha">
                <div className="filtro-titulo">
                  <Calendar className="icon" size={18} />
                  Filtrar por fecha
                </div>
                
                <div className="filtro-grupo">
                  <label className="filtro-label">Desde:</label>
                  <input 
                    type="date" 
                    className="filtro-campo"
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                   
                  />
                </div>
                
                <div className="filtro-grupo">
                  <label className="filtro-label">Hasta:</label>
                  <input 
                    type="date" 
                    className="filtro-campo"
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                   
                  />
                </div>
                
                <div className="filtro-botones">
                  <button 
                    className="btn-filtro-aplicar"
                    onClick={aplicarFiltroFechas}
                    disabled={!fechaInicio && !fechaFin}
                  >
                    <Search size={14} className="btn-icon" />
                    Aplicar
                  </button>
                  
                  {(fechasAplicadas.inicio || fechasAplicadas.fin) && (
                    <button 
                      className="btn-filtro-limpiar"
                      onClick={limpiarFiltroFechas}
                    >
                      <X size={14} className="btn-icon" />
                      Limpiar
                    </button>
                  )}
                </div>
              </div>
              
              {/* Información del filtro aplicado */}
              {(fechasAplicadas.inicio || fechasAplicadas.fin) && (
                <div className="filtro-activo">
                  <Clock size={16} className="icon" />
                  <span>
                    Filtrando por periodo: {fechasAplicadas.inicio ? new Date(fechasAplicadas.inicio).toLocaleDateString() : 'Inicio'} 
                    {' - '} 
                    {fechasAplicadas.fin ? new Date(fechasAplicadas.fin).toLocaleDateString() : 'Actualidad'}
                  </span>
                </div>
              )}
            </div>
          </section>
          
          {/* Tarjetas de métricas */}
          <div className="grid grid-cols-4 metrica-tarjeta">
            <TarjetaMetrica 
              icono={<Truck size={24} color="white" />}
              titulo="Total Servicios"
              valor={totalesFiltrados.total}
              colorBorde="var(--color-primario-oscuro)"
              colorIcono="var(--color-primario-oscuro)"
            />
            
            <TarjetaMetrica 
              icono={<CheckCircle size={24} color="white" />}
              titulo="En Tiempo"
              valor={totalesFiltrados.enTiempo}
              //valorAdicional={`${metricas.porcentajeEnTiempo}%`}
              colorBorde="var(--color-en-tiempo)"
              colorIcono="var(--color-en-tiempo)"
            />
            
            <TarjetaMetrica 
              icono={<AlertTriangle size={24} color="white" />}
              titulo="Retrasados"
              valor={totalesFiltrados.retrasados}
              //valorAdicional={`${100 - totalesFiltrados.porcentajeEnTiempo}%`}
              colorBorde="var(--color-retrasado)"
              colorIcono="var(--color-retrasado)"
            />
            
            <TarjetaMetrica 
              icono={<Clock size={24} color="white" />}
              titulo="Sin Calculo"
              valor={totalesFiltrados.sinCalculo}
              valorAdicional=""
              colorBorde="var(--color-secundario)"
              colorIcono="var(--color-secundario)"
            />
          </div>
          
          {/* Gráficas */}
          <div className="grid grid-cols-2" style={{marginBottom: '24px'}}>
            {/* Distribución */}
            <div className="card grafico-contenedor">
              <div className="card-body">
                <EncabezadoGrafico titulo="Distribución de Servicios" />
                <div className="grafico-cuerpo">
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <defs>
                        <linearGradient id="colorEnTiempo" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="var(--color-en-tiempo)" stopOpacity={0.8}/>
                          <stop offset="100%" stopColor="var(--color-en-tiempo)" stopOpacity={0.6}/>
                        </linearGradient>
                        <linearGradient id="colorRetrasado" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="var(--color-retrasado)" stopOpacity={0.8}/>
                          <stop offset="100%" stopColor="var(--color-retrasado)" stopOpacity={0.6}/>
                        </linearGradient>
                        <linearGradient id="colorSinCalculo" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="var(--color-sinCalculo)" stopOpacity={0.8}/>
                          <stop offset="100%" stopColor="var(--color-sinCalculo)" stopOpacity={0.6}/>
                        </linearGradient>
                      </defs>
                      <Pie
                        data={datosPie}
                        cx="50%"
                        cy="50%"
                        labelLine={true}
                        outerRadius={100}
                        innerRadius={60} // Donut chart
                        fill="#8884d8"
                        dataKey="value"
                        paddingAngle={5}
                        label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                      >
                        {datosPie.map((entry, index) => (
                          <Cell 
                            key={`cell-${index}`} 
                            fill={entry.color} 
                            stroke={entry.color}
                            strokeWidth={3}
                          />
                        ))}
                      </Pie>
                      <Tooltip 
                        formatter={(value) => [`${value} servicios`, ""]} 
                        contentStyle={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                          border: 'none'
                        }}
                      />
                      <Legend 
                        verticalAlign="bottom" 
                        height={36} 
                        iconType="circle"
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
            
            {/* Tendencia por Fecha */}
           
            
            {/* Desempeño por Transportista */  transportistaGrafica && transportistaGrafica.length > 0  ?
            <div className="card grafico-contenedor">
              <div className="card-body">
                <EncabezadoGrafico titulo="Desempeño por Transportista" />
                <div className="grafico-cuerpo">
                  <ResponsiveContainer width="100%" height="100%">

                  <BarChart
                      data={transportistaGrafica}
                      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                      <defs>
                        <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor="var(--color-primario-oscuro)" stopOpacity={0.8}/>
                          <stop offset="95%" stopColor="var(--color-primario-oscuro)" stopOpacity={0.4}/>
                        </linearGradient>
                        <linearGradient id="colorPorcentaje" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor="var(--color-acento)" stopOpacity={0.8}/>
                          <stop offset="95%" stopColor="var(--color-acento)" stopOpacity={0.4}/>
                        </linearGradient>
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#EAEAEA" opacity={0.5} />
                      <XAxis 
                        dataKey="localidad" 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                      />
                      <YAxis 
                        yAxisId="left" 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                        label={{ value: 'Servicios', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fill: 'var(--color-texto-claro)' }}}
                      />
                      <YAxis 
                        yAxisId="right" 
                        orientation="right" 
                        tickFormatter={(value) => `${value}%`} 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                        label={{ value: 'Porcentaje', angle: 90, position: 'insideRight', style: { textAnchor: 'middle', fill: 'var(--color-texto-claro)' }}}
                      />
                      <Tooltip 
                        contentStyle={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                          border: 'none'
                        }}
                      />
                      <Legend iconType="circle" />
                      <Bar 
                        yAxisId="left" 
                        name="Total Servicios" 
                        dataKey="total" 
                        fill="url(#colorTotal)" 
                        radius={[4, 4, 0, 0]}
                        barSize={30}
                      />
                      <Bar 
                        yAxisId="right" 
                        name="% En Tiempo" 
                        dataKey="porcentajeEnTiempo" 
                        fill="url(#colorPorcentaje)" 
                        radius={[4, 4, 0, 0]}
                        barSize={30}
                      />
                    </BarChart>
                   
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
            :null }
            
            {/* Comparativa entre Localidades */ localidadGrafica ? 
            <div className="card grafico-contenedor">
              <div className="card-body">
                <EncabezadoGrafico titulo="Comparativa entre Localidades" />
                <div className="grafico-cuerpo">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      data={localidadGrafica}
                      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                      <defs>
                        <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor="var(--color-primario-oscuro)" stopOpacity={0.8}/>
                          <stop offset="95%" stopColor="var(--color-primario-oscuro)" stopOpacity={0.4}/>
                        </linearGradient>
                        <linearGradient id="colorPorcentaje" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor="var(--color-acento)" stopOpacity={0.8}/>
                          <stop offset="95%" stopColor="var(--color-acento)" stopOpacity={0.4}/>
                        </linearGradient>
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#EAEAEA" opacity={0.5} />
                      <XAxis 
                        dataKey="localidad" 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                      />
                      <YAxis 
                        yAxisId="left" 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                        label={{ value: 'Servicios', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fill: 'var(--color-texto-claro)' }}}
                      />
                      <YAxis 
                        yAxisId="right" 
                        orientation="right" 
                        tickFormatter={(value) => `${value}%`} 
                        tick={{ fill: 'var(--color-texto)' }}
                        axisLine={{ stroke: 'var(--color-borde)' }}
                        label={{ value: 'Porcentaje', angle: 90, position: 'insideRight', style: { textAnchor: 'middle', fill: 'var(--color-texto-claro)' }}}
                      />
                      <Tooltip 
                        contentStyle={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                          border: 'none'
                        }}
                      />
                      <Legend iconType="circle" />
                      <Bar 
                        yAxisId="left" 
                        name="Total Servicios" 
                        dataKey="total" 
                        fill="url(#colorTotal)" 
                        radius={[4, 4, 0, 0]}
                        barSize={30}
                      />
                      <Bar 
                        yAxisId="right" 
                        name="% En Tiempo" 
                        dataKey="porcentage" 
                        fill="url(#colorPorcentaje)" 
                        radius={[4, 4, 0, 0]}
                        barSize={30}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>: null}
          </div> 
          
          {/* Tabla de servicios */
          movimientosFiltrados ? 
          <div>
          <TablePageablePerRequest            
            titulo={<h3> Movimientos </h3>}
            listaTemp={ movimientosFiltrados }
            columnas={ obtenerColumnas()
       
            }
            hook={changePage}
            hookTotalByPage={changeTamaño}
            elementosPorPagina={tamaño}
            CSVDownload={downloadExcel}
            id="id"
            selected={(e) => setMovimiento(e)} 
            csvname="Solicitudes"
            busquedaHook={buscarMov}
            loader={ <TruckLoader 
              isLoading={isloaderTable} 
              message="Cargando datos de la tabla..."
            />}
            // resaltarFuncion={(e)=> !e.idMovimiento? true: false}
            //resaltarColor={"rgba(223, 58, 58, 0.47)"}
          />
          </div>
          :null}
        </div>
        
        {/* Modal de detalle del servicio */  }
        
      </main>: null }
       {isloading ? (
              <LoadingScreen
                loading={isloading }
              />
            ):null}

            <>
                  {dataTaskDownload?.status ?
                  <ExcelDownloadLoader  data={dataTaskDownload} reset={resetDownload}></ExcelDownloadLoader>
                      :null}
                  </>
    </div>
          
  );
};

export default DashboardAsignaciones;